import styled from "@emotion/styled";

export const ErrorCaption = ({ message }: { message: string }) => {
  return <ErrorMsg>{message}</ErrorMsg>;
};

const ErrorMsg = styled.span`
  padding: 0 16px;
  ${({ theme }) => theme.font.Caption};
  color: ${({ theme }) => theme.color.red[60]};
`;
